import React, { useState, useEffect, memo } from 'react';
import { Switch, message } from 'antd';
import TimeSelect from 'components/form/TimeSelect';
import { IproviderAvailabilityItem, TimeItemType } from 'types/appointmentSetting';
import { PlusIcon } from 'components/MenuIcons';
import trashIcon from 'assets/common/trash.svg';
import s from './s.module.less';

type Props = {
    weekItemData?: IproviderAvailabilityItem;
    changeTimeList?: (val: IproviderAvailabilityItem) => void;
};

const initValues: TimeItemType = {
    fromHour: undefined,
    fromMinute: undefined,
    toHour: undefined,
    toMinute: undefined,
};

const WeekItem = ({ weekItemData, changeTimeList }: Props) => {
    const [hourFromToData, setHourFromToData] = useState<TimeItemType[]>([]);

    const callBackFunc = (val: TimeItemType[]) => {
        changeTimeList?.({
            weekDay: weekItemData?.weekDay,
            hourFromTo: val,
        });
    };

    const onSwitchChange = (checked: boolean) => {
        const newData = [...hourFromToData];
        if (checked === true) {
            newData.push(initValues);
        } else {
            newData.splice(0, hourFromToData.length);
            callBackFunc(newData);
        }
        setHourFromToData(newData);
    };

    const addItem = () => {
        if (hourFromToData.length === 10) return message.error('Maximum 10 time slots per day');
        const newData = [...hourFromToData];
        newData.push(initValues);
        setHourFromToData(newData);
    };

    const deleteItem = (i: number) => {
        const newData = [...hourFromToData];
        newData.splice(i, 1);
        setHourFromToData(newData);
        callBackFunc(newData);
    };

    const timePickerFunc = (i: number, val?: TimeItemType) => {
        if (!val) return;
        const newData = [...hourFromToData];
        newData[i] = val;
        setHourFromToData(newData);
        callBackFunc(newData);
    };

    useEffect(() => {
        if (weekItemData) {
            setHourFromToData(weekItemData?.hourFromTo || []);
        }
    }, [weekItemData]);

    return (
        <div className={s.wrap}>
            <div className={s.leftBlock}>
                <div className={s.switchDay}>
                    <Switch
                        checked={hourFromToData.length > 0}
                        onChange={(checked: boolean) => onSwitchChange(checked)}
                    />
                    <span className={s.weekDayLabel}>{weekItemData?.weekDay}</span>
                </div>

                <div className={s.slotsCol}>
                    {hourFromToData && hourFromToData.length >= 1 ? (
                        hourFromToData.map((item, i) => {
                            const otherTimes = hourFromToData.filter((_, index) => index !== i);
                            return (
                                <div key={`${weekItemData?.weekDay}-${i}`} className={s.slotRow}>
                                    <div className={s.timeBlock}>
                                        <TimeSelect
                                            variant="availability"
                                            value={item}
                                            onChange={(val) => timePickerFunc(i, val)}
                                            disabledTimes={otherTimes}
                                        />
                                    </div>
                                    {i === hourFromToData.length - 1 ? (
                                        <button
                                            type="button"
                                            className={s.plusWrap}
                                            onClick={() => addItem()}
                                            aria-label="Add time range"
                                        >
                                            {PlusIcon}
                                        </button>
                                    ) : (
                                        <span className={s.plusPlaceholder} aria-hidden />
                                    )}
                                    <button
                                        type="button"
                                        className={s.trashBtn}
                                        onClick={() => deleteItem(i)}
                                        aria-label="Remove time range"
                                    >
                                        <img src={trashIcon} alt="" />
                                    </button>
                                </div>
                            );
                        })
                    ) : (
                        <span className={s.emptyText}>Unavailable</span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default memo(WeekItem);
